import React, { useEffect, useState } from 'react';
import { Loader2, Mail } from 'lucide-react';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogTitle } from '../ui/dialog';
import { Title, btnOrange, btnOutline, fieldCls } from '../bb/bbShared';
import { piFetch } from './piShared';

const ROLE_LABEL = { commercial: 'Commercial', commerciale: 'Commercial', admin: 'Direction', super_admin: 'Direction', business_manager: 'Business Manager', directeur_regional: 'DR', directeur_commercial: 'Directeur commercial' };

export const PiEmailDialog = ({ open, onClose, token, point }) => {
  const [users, setUsers] = useState([]);
  const [sel, setSel] = useState([]);
  const [msg, setMsg] = useState('');
  const [q, setQ] = useState('');
  const [sending, setSending] = useState(false);

  useEffect(() => {
    if (!open) return;
    setSel(point?.commercial_id ? [point.commercial_id] : []);
    setMsg('');
    setQ('');
    piFetch(token, '/pi/destinataires').then(setUsers).catch(e => toast.error(e.message));
  }, [open, token, point]);

  const toggle = (id) => setSel(s => (s.includes(id) ? s.filter(x => x !== id) : [...s, id]));
  const send = async () => {
    setSending(true);
    try {
      const r = await piFetch(token, `/pi/email/${point.id}`, { method: 'POST', body: JSON.stringify({ user_ids: sel, message: msg }) });
      toast.success(`Compte rendu envoyé à ${r.sent.join(', ')}`);
      if (r.failed.length) toast.error(`Échec pour : ${r.failed.join(', ')}`);
      onClose(true);
    } catch (e) { toast.error(e.message); } finally { setSending(false); }
  };

  return (
    <Dialog open={open} onOpenChange={v => !v && onClose(false)}>
      <DialogContent className="max-w-lg" data-testid="pi-email-dialog">
        <DialogTitle asChild><Title className="text-2xl">Envoyer le compte rendu</Title></DialogTitle>
        <p className="text-sm text-slate-500 -mt-1">Commerciaux en tête de liste. Le PDF du point (sans la note confidentielle) est joint au mail.</p>
        <input className={fieldCls} placeholder="Rechercher un utilisateur…" value={q} onChange={e => setQ(e.target.value)} data-testid="pi-email-search" />
        <div className="max-h-64 overflow-y-auto rounded-xl border border-[#E2DFD8] divide-y divide-[#EEECE8]">
          {users.filter(u => `${u.name || ''} ${u.email}`.toLowerCase().includes(q.trim().toLowerCase())).map(u => (
            <label key={u.id} className="flex items-center gap-3 px-3 py-2 text-sm cursor-pointer hover:bg-[#F3F2EE]">
              <input type="checkbox" checked={sel.includes(u.id)} onChange={() => toggle(u.id)} data-testid={`pi-email-user-${u.id}`} />
              <span className="flex-1"><b>{u.name || u.email}</b> <span className="text-xs text-slate-500">· {u.email}</span></span>
              <span className="text-[11px] font-semibold text-slate-500">{ROLE_LABEL[u.role] || u.role}</span>
            </label>
          ))}
        </div>
        <textarea rows={3} className={fieldCls} placeholder="Message d'accompagnement (facultatif)" value={msg} onChange={e => setMsg(e.target.value)} data-testid="pi-email-message" />
        <div className="flex justify-end gap-2">
          <button type="button" className={btnOutline} onClick={() => onClose(false)}>Annuler</button>
          <button type="button" className={btnOrange} disabled={!sel.length || sending} onClick={send} data-testid="pi-email-send">
            {sending ? <Loader2 className="h-4 w-4 animate-spin" /> : <Mail className="h-4 w-4" />}Envoyer ({sel.length})
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
